import { yupResolver } from '@hookform/resolvers/yup'
import { Auth } from 'aws-amplify'
import { NextSeo } from 'next-seo'
import { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import { object, string } from 'yup'

// import AuthBg from '@/assets/illustrations/auth.svg'
// import bottomImg from '@/assets/illustrations/home.svg'
import Button, { ButtonVariant } from '@/components/button'
import Input from '@/components/input'
import Link from '@/components/link'
import Textarea from '@/components/textarea'
import handleApiError from '@/utils/handle-api-error'

// import ContactUs from '@/pages/contactUs'

const schema = object({
  email: string().email().required(),
  password: string().min(8).required(),
}).required()

const ContactUs = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) })

  const [usernameExistsError, toggleUsernameExistsError] = useState('')

  const onSubmit = useCallback(
    ({ name, mobileNum, email }) => {
      toggleUsernameExistsError('')
      Auth.signUp({
        username: name,
        useremail: email,
        mobile: mobileNum,
      }).catch((e) => {
        if (e?.code === 'UsernameExistsException') {
          toggleUsernameExistsError(email)
        } else {
          handleApiError(e)
        }
      })
    },
    [toggleUsernameExistsError],
  )

  return (
    <div className='h-bg-intr flex h-[100%] min-h-full flex-wrap items-center bg-theme-turquoise'>
      <NextSeo title='Contact Us' />
      <div className='custom-page mt-[50px] w-[87%] flex-[0_0_100%]'>
        <div className='relative'>
          <h1 className='custom-heading'>get in touch</h1>
          <div className='py-4'>
            <form
              className='auth-form flex flex-col space-y-2'
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className='custom-form-font w-full '>
                <Input
                  id='name'
                  name='name'
                  label='Name'
                  type='text'
                  required
                  register={register}
                  errors={errors}
                />

                <Input
                  name='mobileNum'
                  label='Mobile'
                  type='tel'
                  required
                  register={register}
                  errors={errors}
                />

                <Input
                  name='email'
                  label='Email'
                  type='email'
                  autoComplete='email'
                  required
                  register={register}
                  errors={errors}
                />
                <div className='textarea-custom'>
                  <Textarea
                    name='query'
                    rows='3'
                    register={register}
                    className='resize-none border-none pl-0 shadow-none'
                    required
                    errors={errors}
                    label='I want to know about '
                  />
                </div>
              </div>
              {Boolean(usernameExistsError) && (
                <p className='text-center text-red-600'>
                  User with email <span>"{usernameExistsError}"</span> already
                  exists. Try{' '}
                  <Link
                    href={`/auth/login?email=${usernameExistsError}`}
                    className='text-red-600 underline hover:text-red-800'
                  >
                    logging in
                  </Link>{' '}
                  or use{' '}
                  <Link
                    href={`/auth/forgot-password?email=${usernameExistsError}`}
                    className='text-red-600 underline hover:text-red-800'
                  >
                    forgot password
                  </Link>{' '}
                  to create a new password.
                </p>
              )}
              <div className='flex w-full items-center justify-start pt-2'>
                <Button
                  variant={ButtonVariant.Primary}
                  bg='bg-[#f59175]'
                  tailFill='#f59175'
                  className='cm-bg w-fit rounded-full !text-base'
                  tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[41%] !h-[9px] md:!h-[16px]'
                >
                  <span className='submit-btn translate-y-0.5 !font-extralight capitalize'>
                    submit
                  </span>
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='custom-page w-[87%] flex-[0_0_100%]'>
        <div className='w-full'>
          <div className='contact-detail'>
            <p className='font-medium uppercase'>contact us</p>
            <div>
              <p className='font-extralight'>
                <span className='font-medium'>M:</span> +91 9731717225
              </p>
              <p className='font-extralight'>
                <span className='font-medium'>E:</span>{' '}
                <Link href='mailto:talk2us@thrivecafe.in'>
                  talk2us@thrivecafe.in
                </Link>
              </p>
            </div>
          </div>
          <div className='quick-links-container border-b border-black'>
            <ul className='flew-no-wrap quick-links flex list-none justify-between whitespace-nowrap'>
              <li className=''>
                <Link href='/FAQ' noUnderline>
                  <span className='relative'>FAQs</span>
                </Link>
              </li>
              <li className=''>
                <Link href='/refundPolicy' noUnderline>
                  <span className='relative'>Refund Policy</span>
                </Link>
              </li>
              <li className=''>
                <Link href='/termsconditions' noUnderline>
                  <span className='relative'>Terms &amp; conditions</span>
                </Link>
              </li>
              <li className=''>
                <Link href='/privacypolicy' noUnderline>
                  <span className='relative'>Privacy policy</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* points in pt
            heading - 24, 28.8, 25
            input, submit - 22, 46, 25
            submit - padding - y-15px x-12px
            contact-us - 21, 25.2, 25
            M, E - 21, *, 25
            quick-links - 20, 33, 25
            bottom-margin - 181.9895
         */}
      </div>
      <style jsx>
        {`
          .contact-detail {
            margin-bottom: 76.03pt;
          }
          .contact-detail p {
            font-size: 30pt;
            line-height: 1.4pt;
          }
          .contact-detail > p {
            margin-bottom: 50.4pt;
          }
          .contact-detail div p:first-child {
            margin-bottom: 42.4pt;
          }
          .custom-page {
            padding-left: 560px;
            padding-right: 555px;
          }
          .custom-heading {
            font-weight: 500;
            font-size: 40pt;
            margin-top: 155px;
            text-transform: uppercase;
          }
          .custom-form-font {
            font-size: 44pt;
            line-height: 92pt;
          }
          .submit-btn {
            font-size: 35pt;
          }
          .quick-links {
            width: 100%;
            font-family: 'Overpass';
            font-weight: 300;
            font-size: 30pt;
            line-height: 49.5pt;
          }
          .quick-links li::after {
            content: '.';
            position: relative;
            font-size: 75px;
            left: 8px;
            bottom: 9px;
          }
          .quick-links li:last-child::after {
            content: '';
          }
          .py-custom {
            max-width: 524px;
            margin: 200px auto 20px;
          }
          .auth-form {
            margin-bottom: 155pt;
          }
          .quick-links-container {
            margin-bottom: 272.97pt;
          }
          @media (max-width: 1920px) {
            .py-custom {
              max-width: calc(
                320px + (524 - 320) * (100vw - 375px) / (1920 - 375)
              );
              margin: calc(115px + (200 - 115) * (100vw - 375px) / (1920 - 375))
                auto 20px;
            }
            .contact-detail {
              margin-bottom: calc(
                25.34pt + (76.03 - 25.34) * (100vw - 375px) / (1920 - 375)
              );
            }
            .contact-detail p {
              font-size: calc(
                10pt + (30 - 10) * (100vw - 360px) / (1920 - 360)
              );
              line-height: calc(
                12.6pt + (1.4 - 12.6) * (100vw - 360px) / (1920 - 360)
              );
            }
            .contact-detail > p {
              margin-bottom: calc(
                12.6pt + (50.4 - 12.6) * (100vw - 360px) / (1920 - 360)
              );
            }
            .contact-detail div p:first-child {
              margin-bottom: calc(
                5.48pt + (42.4 - 5.48) * (100vw - 360px) / (1920 - 360)
              );
            }
            .custom-page {
              padding-left: calc(
                26px + (560 - 60) * (100vw - 360px) / (1920 - 360)
              );
              padding-right: calc(
                22px + (555 - 50) * (100vw - 360px) / (1920 - 360)
              );
            }
            .custom-heading {
              font-weight: 500;
              font-size: calc(
                12pt + (40 - 12) * (100vw - 360px) / (1920 - 360)
              );
              margin-top: calc(
                50px + (155 - 50) * (100vw - 360px) / (1920 - 360)
              );
              text-transform: uppercase;
            }
            .custom-form-font {
              font-size: calc(
                11pt + (44 - 11) * (100vw - 360px) / (1920 - 360)
              );
              line-height: calc(
                23pt + (92 - 23) * (100vw - 360px) / (1920 - 360)
              );
            }
            .submit-btn {
              font-size: calc(
                11pt + (35 - 11) * (100vw - 360px) / (1920 - 360)
              );
            }
            .quick-links {
              width: 100%;
              font-family: 'Overpass';
              font-weight: 300;
              font-size: calc(9pt + (30 - 9) * (100vw - 360px) / (1920 - 360));
              line-height: calc(
                16.5pt + (49.5 - 16.5) * (100vw - 281pt) / (1920 - 360)
              );
            }
            .quick-links li::after {
              content: '.';
              position: relative;
              font-size: calc(
                25px + (75 - 25) * (100vw - 360px) / (1920 - 360)
              );
              left: calc(4px + (8 - 4) * (100vw - 360px) / (1920 - 360));
              bottom: calc(2px + (9 - 2) * (100vw - 360px) / (1920 - 360));
            }
            .auth-form {
              margin-bottom: calc(
                40.6pt + (155 - 40.6) * (100vw - 375px) / (1920 - 375)
              );
            }
            .quick-links-container {
              margin-bottom: calc(
                90.99pt + (272.97 - 90.99) * (100vw - 375px) / (1920 - 375)
              );
            }
          }
        `}
      </style>
    </div>
  )
}
export default ContactUs
